import { Dialog, DialogType } from '@fluentui/react';
import React from 'react';

export interface IGenericDialogProps {
	visible: boolean;
	onDismiss: () => void;
	title: string;
	fullScreen: boolean;
}

export default class GenericDialog extends React.Component<
	IGenericDialogProps,
	{}
> {
	render(): React.ReactNode {
		if (!this.props.visible) {
			return <></>;
		}

		let maxWidth = this.props.fullScreen ? '100% !important' : '800px !important';
		let maxHeight = this.props.fullScreen ? '100%' : '600px';

		const modelProps = {
			isBlocking: true,
			styles: {
				main: {
					width: 'calc(100% - 40px) !important',
					height: maxHeight,
					maxWidth: maxWidth,
				},
			},
		};

		const dialogContentProps = {
			type: DialogType.normal,
			title: this.props.title,
		};

		return (
			<Dialog
				dialogContentProps={dialogContentProps}
				modalProps={modelProps}
				hidden={false}
				onDismiss={() => {
					this.props.onDismiss();
				}}
			>
				{this.props.children}
			</Dialog>
		);
	}
}
